<template>
  <div class="staff-detail">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/yuangong/list2"
      @before-fetch="beforeFetch"
    >
      <template #operate>
        <el-button type="primary" @click="$router.push('/staff/0')">新增员工</el-button>
        <el-button type="primary" @click="visible = true">导出</el-button>
      </template>
      <email-table-column slot="email"></email-table-column>
      <el-table-column slot="bumen" show-overflow-tooltip label="公司">
        <template v-slot="{row}">
          <span>{{row | bumen}}</span>
        </template>
      </el-table-column>
      <photo-table-column slot="photo"></photo-table-column>
      <el-table-column slot="caozuo" label="操作" width="150" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="$router.push(`/staff/${row.id}`)">编辑</el-button>
          <el-button type="text" @click="setLeave(row, $event)">离职</el-button>
          <el-button type="text" @click="remove(row, $event)">删除</el-button>
        </template>
      </el-table-column>
    </c-table>
    <export v-model="visible"></export>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import DepartmentCascade from '@/components/service/department-cascade'
import Export from './#detail-export'
import mixin from '@/mixins'

export default {
  name: 'staff-detail',
  mixins: [ mixin ],
  components: { CTable, Export },
  data () {
    return {
      visible: false,
      fields: [
        {
          prop: 'name',
          placeholder: '姓名/工号',
          clearable: true
        },
        {
          prop: 'department',
          placeholder: '公司',
          component: DepartmentCascade,
          value: []
        }
      ],
      columns: [
        { prop: 'id', label: '工号', width: 100 },
        { prop: 'name', label: '姓名', width: 100 },
        { slot: 'bumen' },
        { prop: 'mobile', label: '手机', width: 140 },
        { slot: 'email' },
        { prop: 'seat', label: '座位', width: 80 },
        { prop: 'area', label: '地区' },
        { prop: 'indate', label: '入职时间', width: 120 },
        { prop: 'zhiwei', label: '职位' },
        { prop: 'level', label: '级别' },
        { prop: 'birth', label: '生日', width: 120 },
        { prop: 'xueli', label: '学历' },
        { prop: 'xuewei', label: '学位', minWidth: 100 },
        { prop: 'xuexiao', label: '学校', minWidth: 100 },
        { prop: 'zhuanye', label: '专业', minWidth: 100 },
        { prop: 'emergency', label: '紧急联系人', minWidth: 120 },
        { prop: 'emergencyphone', label: '紧急联系人电话', minWidth: 140 },
        { slot: 'photo' },
        { slot: 'caozuo' }
      ]
    }
  },
  methods: {
    beforeFetch (params) {
      [ (params.jiagou_first), (params.jiagou_second), (params.jiagou_third), (params.jiagou_forth) ] = params.department
      params.gong_id = params.name
      delete params.department
    },
    remove (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.name,
        operate: () =>
          this.$http.post(`/yuangong/delete2`, {
            gong_id: row.id
          }),
        callback: () => {
          this.$refs.table.reload()
        }
      })
    },
    setLeave (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.name,
        operate: () =>
          this.$http.post(`/yuangong/out`, {
            gong_id: row.id
          }),
        callback: () => {
          this.$refs.table.reload()
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
